/**
 * @generated SignedSource<<9aed6e6cbc6676e7bd4cc05c0f5959a3>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type InlineCommentsQuery_content_PaginatedContentListWithChild_nodes_Content_space_Space =
  {
    __typename?: "Space";
    id: string | null;
  };
export type InlineCommentsQuery_content_PaginatedContentListWithChild_nodes_Content_operations_OperationCheckResult =
  {
    __typename?: "OperationCheckResult";
    operation: string | null;
    targetType: string | null;
  };
export type InlineCommentsQuery_content_PaginatedContentListWithChild_nodes_Content =
  {
    __typename?: "Content";
    id: string | null;
    type: string | null;
    space: InlineCommentsQuery_content_PaginatedContentListWithChild_nodes_Content_space_Space | null;
    operations: Array<InlineCommentsQuery_content_PaginatedContentListWithChild_nodes_Content_operations_OperationCheckResult | null> | null;
  };
export type InlineCommentsQuery_content_PaginatedContentListWithChild = {
  __typename?: "PaginatedContentListWithChild";
  nodes: Array<InlineCommentsQuery_content_PaginatedContentListWithChild_nodes_Content | null> | null;
};
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_createdAt_ConfluenceDate =
  {
    __typename?: "ConfluenceDate";
    value: string;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_links_Map_LinkType_String =
  {
    __typename?: "Map_LinkType_String";
    webui: string | null;
    editui: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    isDangling: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
    commentResolveProperties: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    inlineText: string | null;
    type: string;
    inlineResolveProperties: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location =

    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment;
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_permissions_CommentPermissions =
  {
    __typename?: "CommentPermissions";
    isEditable: boolean;
    isRemovable: boolean;
    isResolvable: boolean;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by =

    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_Anonymous
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_KnownUser
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_UnknownUser
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_User;
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version =
  {
    __typename?: "Version";
    when: string | null;
    number: number | null;
    by: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_User =
  {
    __typename?: "User";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author =

    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_KnownUser
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_UnknownUser
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_User;
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_createdAt_ConfluenceDate =
  {
    __typename?: "ConfluenceDate";
    value: string;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_links_Map_LinkType_String =
  {
    __typename?: "Map_LinkType_String";
    webui: string | null;
    editui: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    isDangling: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
    commentResolveProperties: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    inlineText: string | null;
    type: string;
    inlineResolveProperties: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location =

    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment;
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_permissions_CommentPermissions =
  {
    __typename?: "CommentPermissions";
    isEditable: boolean;
    isRemovable: boolean;
    isResolvable: boolean;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by =

    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_Anonymous
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_KnownUser
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_UnknownUser
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_User;
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version =
  {
    __typename?: "Version";
    when: string | null;
    number: number | null;
    by: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_User =
  {
    __typename?: "User";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author =

    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_KnownUser
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_UnknownUser
    | InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_User;
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment =
  {
    __typename?: "Comment";
    id: string;
    contentStatus: string;
    createdAtNonLocalized: string;
    parentId: string | null;
    body: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_body_DocumentBody;
    createdAt: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_createdAt_ConfluenceDate;
    links: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_links_Map_LinkType_String;
    location: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location;
    permissions: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_permissions_CommentPermissions;
    version: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version;
    author: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author;
  };
export type InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment = {
  __typename?: "Comment";
  id: string;
  contentStatus: string;
  createdAtNonLocalized: string;
  parentId: string | null;
  body: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_body_DocumentBody;
  createdAt: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_createdAt_ConfluenceDate;
  links: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_links_Map_LinkType_String;
  location: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location;
  permissions: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_permissions_CommentPermissions;
  version: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version;
  author: InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author;
  replies: Array<InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment | null>;
};
export type InlineCommentsQuery_comments_PaginatedCommentList = {
  __typename?: "PaginatedCommentList";
  nodes: Array<InlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment | null> | null;
};
export type InlineCommentsQuery_Query = {
  __typename?: "Query";
  content: InlineCommentsQuery_content_PaginatedContentListWithChild | null;
  comments: InlineCommentsQuery_comments_PaginatedCommentList | null;
};
export type InlineCommentsQueryVariables = Exact<{
  pageId: Scalars["ID"]["input"];
}>;
export type InlineCommentsQuery = InlineCommentsQuery_Query;
